import React, { useState } from 'react'
import { useTranslation } from 'react-i18next';
import { colors, glyphs } from '../../Styles';
import { Overlay } from '..';
import { ButtonTypes } from '../../Definitions';
import { NewButtonList } from '../BaseComponents/newButton';
interface Marking_Props {
  selectedAnimal: number
}
/**
 * Marking
 * @param selectedAnimal
 * @returns
 */
export default function Marking({ selectedAnimal }:Marking_Props) {
  const {t} = useTranslation()
  const [editMode, setEditMode] = useState<boolean>(false)

  return ( <>
    { editMode ? <Overlay/> : <></> }
    <div style={{position: "relative", height: "calc(100% - 50px)"}}>
    <div style={{display: "flex", position: "relative", justifyContent: "end", padding: "0px 20px", zIndex: editMode? "9999" : "0"}}>
        { editMode 
          ? <NewButtonList
              contents={[ t("buttons.save", {defaultValue: "save"}), t("buttons.cancel", {defaultValue: "cancel"}), t("buttons.add", {defaultValue: "add"}), t("buttons.edit", {defaultValue: "edit"}) ]}
              buttonType={ButtonTypes.tableButton}
              startEnhancers={[ glyphs.Check({}), glyphs.Close({}), glyphs.Add({}), glyphs.Edit({}) ]}
              onClick={(i => {
                if (i === 0) {} // TODO: Save to db
                if (i === 1) {setEditMode(false)}
              })}
              disabled={[ false, false, true, true ]}
              overrides={(index) => ({
                baseStyles: { backgroundColor: index === 3 ? colors.greyPrimary : colors.greySecondary },
                hoverStyles: { backgroundColor: colors.greyPrimary },
                disabledStyles: { opacity: index === 3 ? 1 : 0.5 },
              })}
            /> 
          : <NewButtonList
              contents={[t("buttons.add", {defaultValue: "add"}), t("buttons.edit", {defaultValue: "edit"})]}
              buttonType={ButtonTypes.tableButton}
              startEnhancers={[ glyphs.Add({}), glyphs.Edit({}) ]}
              onClick={(i => {
                if (i === 0) {} // TODO: Add new event
                if (i === 1) {setEditMode(true)}
              })}
            />
        }
      </div>
      <div style={{height: "calc(100% - 10px)", position: "relative", zIndex: editMode? "9999" : "0", backgroundColor: colors.greyLightSecondary, border: "5px solid "+colors.greyPrimary, borderRadius: "10px", overflowY: "hidden"}}>
      
      {/* CONTENT HER */}
      
      </div>
    </div>
  </> );
}